import {SortEvent} from '@shared/table-header-sortable/table-header-sortable.directive';

export const DEFAULT_SORT_TYPE: SortEvent = {column: 'name', direction: 'asc'};
